var map = {
	"./hdrelay-2021": [
		342,
		0,
		80
	],
	"./hdrelay-2021.tsx": [
		342,
		0,
		80
	],
	"./hdrelay-minimal": [
		343,
		81
	],
	"./hdrelay-minimal.tsx": [
		343,
		81
	],
	"./no-settings": [
		341,
		2
	],
	"./no-settings.tsx": [
		341,
		2
	],
	"./timeelapsed-2021": [
		344,
		0,
		3
	],
	"./timeelapsed-2021.tsx": [
		344,
		0,
		3
	],
	"./timeelapsed-2021/AllowedWidth": [
		271,
		82
	],
	"./timeelapsed-2021/AllowedWidth.tsx": [
		271,
		82
	],
	"./timeelapsed-2021/DowloadComposition": [
		272,
		83
	],
	"./timeelapsed-2021/DowloadComposition.tsx": [
		272,
		83
	],
	"./timeelapsed-2021/HotLink": [
		273,
		57
	],
	"./timeelapsed-2021/HotLink.tsx": [
		273,
		57
	],
	"./timeelapsed-2021/ImageNavigation": [
		274,
		84
	],
	"./timeelapsed-2021/ImageNavigation.tsx": [
		274,
		84
	],
	"./timeelapsed-2021/ReviewLastHours": [
		275,
		85
	],
	"./timeelapsed-2021/ReviewLastHours.tsx": [
		275,
		85
	],
	"./timeelapsed-2021/Tile": [
		276,
		86
	],
	"./timeelapsed-2021/Tile.tsx": [
		276,
		86
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 496;
module.exports = webpackAsyncContext;